import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  type AppLocale,
  readStoredLocale,
  resolvePreferredLocale,
  writeStoredLocale,
} from './localeStorage'

import enCommon from '../locales/en/common.json'
import enAuth from '../locales/en/auth.json'
import enField from '../locales/en/field.json'
import enJobs from '../locales/en/jobs.json'
import enSettings from '../locales/en/settings.json'
import esCommon from '../locales/es/common.json'
import esAuth from '../locales/es/auth.json'
import esField from '../locales/es/field.json'
import esJobs from '../locales/es/jobs.json'
import esSettings from '../locales/es/settings.json'

export const I18N_NAMESPACES = ['common', 'auth', 'field', 'jobs', 'settings'] as const

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    field: enField,
    jobs: enJobs,
    settings: enSettings,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    field: esField,
    jobs: esJobs,
    settings: esSettings,
  },
}

const initialLocale = resolvePreferredLocale(null, readStoredLocale())

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale,
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: [...I18N_NAMESPACES],
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLocale === 'es' ? 'es' : 'en'
}

/** Apply language everywhere: i18n, document.lang, localStorage. */
export async function applyAppLocale(locale: AppLocale): Promise<void> {
  writeStoredLocale(locale)
  await i18n.changeLanguage(locale)
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'es' ? 'es' : 'en'
  }
}

export function getAppLocale(): AppLocale {
  const lng = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
  return lng === 'es' ? 'es' : 'en'
}

export default i18n
